package uz.ferro.erp.api

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json


@OptIn(ExperimentalSerializationApi::class)
val jsonSerializer = Json {
    explicitNulls = false
    ignoreUnknownKeys = true
}

object BaseUrl {
//    const val HOST = "http://localhost:8008"
//    const val HOST = "https://erp.ferro.uz"
    const val HOST = "https://crm.ferro.uz"

    private const val BASE_API = "$HOST/api/"

    fun get(path: String): String {
        return BASE_API + path.removePrefix("/")
    }
}